// Table dice intent builders. Returns a { domain:'dice', kind, ... } object the
// server's match:intent handler routes into diceService, which mints the die,
// draws every rolled value and writes it to MatchState so both seats fold the
// same die from the diff. Keep payload shapes in lockstep with
// valkenhall-server/src/match/diceService.js.

let _seq = 0;
function nextKey(dieType) {
  _seq += 1;
  return `die-${dieType}-${Date.now()}-${_seq}`;
}

// `value` is the face the dropped die already shows (a spawn is not a roll);
// the server keeps it when it is a face of that body, else draws one. `on`
// is the card the die was dropped on and where on it, in the card's frame
// ({ cardId, u, w }), or null for a die loose on the table at (x, z).
export function spawnDiceIntent({ dieType, seat, x, z, value, on = null }) {
  return { domain: 'dice', kind: 'spawn', dieType, seat, x, z, value, on, idempotencyKey: nextKey(dieType) };
}

export function moveDiceIntent(diceId, x, z, on = null) {
  return { domain: 'dice', kind: 'move', diceId, x, z, on };
}

export function rollDiceIntent(diceId) {
  return { domain: 'dice', kind: 'roll', diceId };
}

export function setDiceFaceIntent(diceId, value) {
  return { domain: 'dice', kind: 'setFace', diceId, value };
}

export function deleteDiceIntent(diceId) {
  return { domain: 'dice', kind: 'delete', diceId };
}

// The palette this seat drops its dice in from now on (a DICE_PALETTES id).
// The server stamps it onto each die at spawn and shows it to the other
// seat, so both clients draw a die in the palette its owner chose.
// `seat` is the acting seat, honoured on the wire for the solo pilot only.
export function setDicePaletteIntent(palette, seat) {
  return { domain: 'dice', kind: 'setPalette', palette, seat };
}
